/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { inject } from "mobx-react";
import { PrintButton } from "./PrintButton";
import { printHandler } from "print/printHandler";
import { getIsInPlaceMode } from "selectors/viewModeSelectors";
import { isSinglePageMode } from "selectors/documentSelectors";
import { getShouldUseModernViewer } from "selectors/appSelectors";
import printIcon from "dc-icons/viewer2021/SDC_Print_18_N.svg";
import printIconLight from "dc-icons/consumption/s_print_light_18.svg";
import printIconEmbedded from "dc-icons/consumption/s_print_18.svg";
import * as constants from "constants/constants";

const icon = (stores, ownProps) => {
  if (!getShouldUseModernViewer(stores) && (getIsInPlaceMode(stores) || isSinglePageMode(stores))) {
    return printIconEmbedded;
  }
  return ownProps.options.color === "light" ? printIcon : printIconLight;
};

const mapStoreToProps = (stores, ownProps) => ({
  onClick: () => {
    printHandler.print({
      triggeredFrom: "reusablePrintComponent"
    });
  },
  icon: icon(stores, ownProps),
  tooltipPlacement: getIsInPlaceMode(stores) ? constants.TOOLTIP_TOP_PLACEMENT : constants.TOOLTIP_BOTTOM_PLACEMENT,
  tooltipDelay: constants.TOOLTIP_DELAY
});

const PrintButtonContainer = inject(mapStoreToProps)(PrintButton);

PrintButtonContainer.defaultProps = {
  options: {
    color: "light"
  }
};

export { PrintButtonContainer };
